import { useCallback, useEffect, useState } from "react"
import { pick, omitBy, keys, isEmpty } from "lodash"
import queryString from "query-string"
import { useLocation } from "react-router"

export function useQueryParamsState(defaultQuery) {
  const { search, pathname } = useLocation()

  let initialQuery = { ...defaultQuery, ...parseQueryParams(search) }

  initialQuery = filterParams(pick(initialQuery, keys(defaultQuery)))

  const [query, setQuery] = useState(initialQuery)
  const updateQuery = useCallback((updateFn) => {
    setQuery((prev) => filterParams(updateFn(prev)))
  }, [])

  useEffect(() => {
    updateQueryParams(query, pathname)
  }, [query, pathname])

  return [query, updateQuery]
}

function filterParams(params) {
  return omitBy(params, isEmpty)
}

function parseQueryParams(string) {
  return queryString.parse(string, {
    arrayFormat: "bracket",
    parseBooleans: true,
  })
}

function updateQueryParams(params, pathname) {
  const query = queryString.stringify(params, {
    arrayFormat: "bracket",
    skipNull: true,
  })
  const location = [pathname, query].filter((i) => i).join("?")
  window.history.replaceState(null, "", location)
}
